import {
  ApiError,
  LoginCredentials,
  LoginResponse,
  RegisterCredentials,
  RegisterResponse,
  User,
} from '@seatix/shared/domain';
import { createNoopInjectionToken } from 'ngxtension/create-injection-token';
import { Observable } from 'rxjs';

export interface AuthProvider {
  login(
    credentials: LoginCredentials,
    turnstileToken?: string,
  ): Observable<LoginResponse>;

  logout(): Observable<void>;

  check(): Observable<{ authenticated: boolean; user?: User }>;

  getIdentity(): Observable<User>;

  register?(
    data: RegisterCredentials,
    turnstileToken?: string,
  ): Observable<RegisterResponse>;

  refreshToken?(): Observable<{ token: string; expires_at: number }>;

  resetPassword?(email: string, turnstileToken?: string): Observable<void>;

  verifyEmail?(token: string): Observable<void>;

  onLoginSuccess(response: LoginResponse): void;

  onLoginFailure(error: ApiError): void;

  onLogoutSuccess(): void;

  onError(error: Error): void;
}

/**
 * Injection token for providing AuthProvider per app
 *
 * @example
 * // In app.config.ts
 * providers: [
 *   provideAuthProvider(CheckInAuthProvider)
 * ]
 *
 * // In component/service
 * const provider = injectAuthProvider();
 */
export const [injectAuthProvider, provideAuthProvider, AUTH_PROVIDER] =
  createNoopInjectionToken<AuthProvider>('AuthProvider');
